var _ = require('../utils/lib.js');
var Liquid = require('liquidjs');

var locales, moneyFormat;

var View = function (l, m) {
  this.engine = Liquid();
  this.templatesSelector = '[type="text/template"]';
  this.templates = {};
  locales = l;
  moneyFormat = m;
  this._registerFilters();
  this._collectTemplates();
};

View.prototype.render = function (outputEle, templateID, data, callback) {
  if (typeof outputEle == 'string') {
    outputEle = document.querySelector(outputEle);
  }
  var newOutputEle = outputEle.cloneNode();
  var tmpl = this.templates[templateID];

  this.engine
    .render(tmpl.template, data)
    .then(function (html) {
      newOutputEle.innerHTML = html;
      outputEle.parentNode.replaceChild(newOutputEle, outputEle);

      if (typeof callback === 'function') {
        callback();
      }
    });
};

/* Private */
View.prototype._collectTemplates = function () {
  var _this = this,
    templates = document.querySelectorAll(this.templatesSelector);
  _.each(templates, function (tmpl) {
    _this._collectTemplate(tmpl);
  });
};

View.prototype._collectTemplate = function (template) {
  var id = template.id;
  this.templates[id] = {
    id: id,
    template: this.engine.parse(template.innerHTML)
  };
};

// Filters
View.prototype._registerFilters = function () {
  this.engine.registerFilter('t', this._t);
  this.engine.registerFilter('money', this._money);
  this.engine.registerFilter('within', this._within);
  this.engine.registerFilter('img_url', this._img_url);

  var _this = this;
  this.engine.registerTag('include', {
    parse: function (token) {
      this.value = token.args.replace(/'/g, '');
    },
    render: function (scope) {
      var tmpl = _this.templates[this.value];
      return _this.engine
        .render(tmpl.template, scope.contexts[0])
        .then(function (html) {
          return html;
        });
    }
  });
};

View.prototype._t = function (translationKey) {
  function getTranslation (translationKey) {
    var key,
      translation = [],
      keyParts = translationKey.split('.');
    try {
      while (keyParts.length) {
        key = keyParts.shift();
        translation = (translation[key] === undefined)? locales[key] : translation[key];
      }
    } catch (e) {
      console.log('translation error', e);
      return 'translation missing: '+translationKey;
    }
    return translation;
  }

  function serializeAguments (args) {
    var params = {},
      lastParam;
    _.each(args, function (arg, i) {
      if (i > 0) { // skip the first argument
        if (i % 2) {
          lastParam = arg;
        } else {
          params[lastParam] = arg;
        }
      }
    });
    return params;
  }

  function setTranslationParams (translation, parameters) {
    var regexp;
    _.eachIn(parameters, function (parameter, value) {
      regexp = new RegExp('{{\\s?'+parameter+'\\s?}}');
      translation = translation.replace(regexp, value);
    });
    return translation;
  }

  var translation = getTranslation(translationKey);
  if (arguments.length > 1) {
    var parameters = serializeAguments(arguments);

    // Handle pluralization
    if (parameters.count != undefined && typeof translation == 'object') { // remember kids 0 == false
      var key = 'other';
      var pluralizationKeys = ['zero','one','two'];
      if (pluralizationKeys[parameters.count] && translation[pluralizationKeys[parameters.count]]) {
        var key = pluralizationKeys[parameters.count];
      }
      translation = translation[key];
    }

    translation = setTranslationParams(translation, parameters);
  }
  return translation;
};

View.prototype._money = function (cents) {
  var amount = (cents / 100).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
  var amount_no_decimals = amount.split('.')[0];
  return moneyFormat.replace('{{amount}}', amount).replace('{{amount_no_decimals}}', amount_no_decimals);
};

View.prototype._within = function (url, collection) {
  // console.log('TODO filter: _within', url, collection);
  return url;
};

View.prototype._img_url = function (src) {
  if (!src) {
    src = 'https://cdn.shopify.com/s/assets/no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c.gif';
  }
  if (typeof src == 'object') {
    src = src.src || src.image || src.image.src;
  }

  var parameters;
  var srcParts = src.split('/');
  var file = srcParts.pop().split('.');
  var path = srcParts.join('/');
  var fileType = file.pop();
  var filename = file.join('.');

  function serializeAguments (args) {
    var params = {},
      lastParam = 'size';
    _.each(args, function (arg, i) {
      if (i > 0) { // skip the first argument
        if (i % 2) {
          params[lastParam] = arg;
        } else {
          lastParam = arg;
        }
      }
    });
    return params;
  }

  if (arguments.length > 1) {
    var args = serializeAguments(arguments);
    parameters = '_'+ ((args.size)? args.size : '') + ((args.crop)? '_crop_'+args.crop : '') + ((args.scale)? '@'+args.scale+'x' : '');
    if (args.format) {
      fileType = (args.format == 'pjpg')? '.progressive.jpg' : '.jpg';
    }
  } else {
    parameters = '_small'
  }

  return path +'/'+ filename + parameters + '.' + fileType;
};

module.exports = View;
